import React, { useEffect, useState } from 'react'

function TimeoutBanner({ durationInMinutes, closeClicked, onTimeComplete }) {
  const [timerDisplay, setTimerDisplay] = useState('')

  let countdownTimeoutInterval

  useEffect(() => {
    startCountdown()

    return () => {
      clearInterval(countdownTimeoutInterval)
    }
  }, [])

  const startCountdown = () => {
    let timerInSeconds = durationInMinutes * 60
    countdownTimeoutInterval = setInterval(function () {
      const minutes = parseInt(timerInSeconds / 60, 10)
      let seconds = parseInt(timerInSeconds % 60, 10)

      seconds = seconds < 10 ? '0' + seconds : seconds

      setTimerDisplay(`${minutes}:${seconds}`)

      if (--timerInSeconds < 0) {
        clearInterval(countdownTimeoutInterval)
        onTimeComplete()
      }
    }, 1000)
  }

  return (
    timerDisplay && (
      <div
        className={`alert alert-warning u-decoBackgroundWhite u-paddingLeft4gu u-paddingVert3gu u-marginBottom1gu`}
      >
        <div className={`u-flex u-flexAlignItemsCenter u-sizeConstrained`}>
          <p className="u-block u-flexAuto u-paddingLeft2gu u-paddingRight5gu">
            <b>Security precaution: </b> Your session will end in {timerDisplay}{' '}
            due to inactivity. To continue your current session, close this
            message.
          </p>
          <button
            type="button"
            onClick={closeClicked}
            className="alert-close-button"
            aria-label="Close"
          ></button>
        </div>
      </div>
    )
  )
}

export default TimeoutBanner
